/**
 * 显示地址文本组件
 */


import AddressText from './AddressText.vue';

export default AddressText;